import * as actions from "../actions/app"

export function setLoading(isLoading) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.setLoading(isLoading))
      resolve()
    })
  }
}

export function handleError (error) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      console.error(error)
      dispatch(actions.incrementErrorCount())
      resolve()
    })
  }
}

export function clearErrors (error) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearErrorCount())
      resolve()
    })
  }
}

export function setAjaxResponse(ajaxResponse) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.setAjaxResponse(ajaxResponse))
      resolve()
    })
  }
}

export function clearAjaxResponse() {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(actions.clearAjaxResponse())
      resolve()
    })
  }
}

export function toggleMenu() {
  return (dispatch) => {
    dispatch(actions.toggleMenu());
  }
}



// WEBPACK FOOTER //
// ./src/actionCreators/app.js